import React, { useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../static/data";
import { toast } from "react-toastify";
import { createevent } from "../../redux/actions/event";
import {
  IMAGE_ACCEPT_WITH_HEIC,
  getImagePreparationErrorMessage,
  prepareImageFilesForUpload,
  readImageFileAsDataUrl,
} from "../../utils/imageUploadPreparation";


const CreateEvent = () => {
  const { seller } = useSelector((state) => state.seller);
  const { success, error } = useSelector((state) => state.events);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [images, setImages] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState("");
  const [originalPrice, setOriginalPrice] = useState();
  const [discountPrice, setDiscountPrice] = useState();
  const [stock, setStock] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (e) => {
    const startDate = new Date(e.target.value);
    const minEndDate = new Date(startDate.getTime() + 3 * 24 * 60 * 60 * 1000);
    setStartDate(startDate);
    setEndDate(null);
    document.getElementById("end-date").min = minEndDate.toISOString().slice(0, 10);
  };

  const handleEndDateChange = (e) => {
    const endDate = new Date(e.target.value);
    setEndDate(endDate);
  };

  const today = new Date().toISOString().slice(0, 10);

  const minEndDate = startDate
    ? new Date(startDate.getTime() + 3 * 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 10)
    : "";

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
    if (success) {
      toast.success("Event created successfully!");
      navigate("/dashboard-events");
      window.location.reload();
    }
  }, [dispatch, error, success]);

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";

    setImages([]);

    try {
      const preparedFiles = await prepareImageFilesForUpload(files);
      const imageDataUrls = await Promise.all(preparedFiles.map(readImageFileAsDataUrl));
      setImages(imageDataUrls);
    } catch (error) {
      console.error("Error preparing sale event images:", error);
      toast.error(getImagePreparationErrorMessage(error));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newForm = new FormData();

    images.forEach((image) => {
      newForm.append("images", image);
    });
    const data = {
      name,
      description,
      category,
      tags,
      originalPrice,
      discountPrice,
      stock,
      images,
      shopId: seller._id,
      start_Date: startDate?.toISOString(),
      Finish_Date: endDate?.toISOString(),
    };
    dispatch(createevent(data));
  };

  return (
    <div className="create-sales-event-container">
      <h5 className="create-sales-event-title">Create Sale Event</h5>
      <form onSubmit={handleSubmit}>
        <div className="create-sales-event-form-group">
          <label>
            Name <span className="required">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={name}
            className="create-sales-event-input"
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your event product name..."
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Description <span className="required">*</span>
          </label>
          <textarea
            cols="30"
            required
            rows="8"
            type="text"
            name="description"
            value={description}
            className="create-sales-event-textarea"
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter your event product description..."
          ></textarea>
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Category <span className="required">*</span>
          </label>
          <select
            className="create-sales-event-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="Choose a category">Choose a category</option>
            {categoriesData &&
              categoriesData.map((i) => (
                <option value={i.title} key={i.title}>
                  {i.title}
                </option>
              ))}
          </select>
        </div>
        
        <div className="create-sales-event-form-group">
          <label>Tags</label>
          <input
            type="text"
            name="tags"
            value={tags}
            className="create-sales-event-input"
            onChange={(e) => setTags(e.target.value)}
            placeholder="Enter your event product tags..."
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>Original Price</label>
          <input
            type="number"
            name="price"
            value={originalPrice}
            className="create-sales-event-input"
            onChange={(e) => setOriginalPrice(e.target.value)}
            placeholder="Enter your event product price..."
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Price (With Discount) <span className="required">*</span>
          </label>
          <input
            type="number"
            name="price"
            value={discountPrice}
            className="create-sales-event-input"
            onChange={(e) => setDiscountPrice(e.target.value)}
            placeholder="Enter your event product price with discount..."
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Product Stock <span className="required">*</span>
          </label>
          <input
            type="number"
            name="price"
            value={stock}
            className="create-sales-event-input"
            onChange={(e) => setStock(e.target.value)}
            placeholder="Enter your event product stock..."
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Event Start Date <span className="required">*</span>
          </label>
          <input
            type="date"
            name="start-date"
            id="start-date"
            value={startDate ? startDate.toISOString().slice(0, 10) : ""}
            className="create-sales-event-input"
            onChange={handleStartDateChange}
            min={today}
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Event End Date <span className="required">*</span>
          </label>
          <input
            type="date"
            name="end-date"
            id="end-date"
            value={endDate ? endDate.toISOString().slice(0, 10) : ""}
            className="create-sales-event-input"
            onChange={handleEndDateChange}
            min={minEndDate}
          />
        </div>
        
        <div className="create-sales-event-form-group">
          <label>
            Upload Images <span className="required">*</span>
          </label>
          <input
            type="file"
            id="upload"
            className="create-sales-event-file-input"
            accept={IMAGE_ACCEPT_WITH_HEIC}
            multiple
            onChange={handleImageChange}
          />
          <div className="create-sales-event-image-preview">
            <label htmlFor="upload">
              <AiOutlinePlusCircle size={30} className="create-sales-event-upload-icon" />
            </label>
            {images &&
              images.map((i) => (
                <img
                  src={i}
                  key={i}
                  alt=""
                  className="create-sales-event-image"
                />
              ))}
          </div>
        </div>
        
        <div className="create-sales-event-form-group">
          <input
            type="submit"
            value="Create"
            className="create-sales-event-submit-button"
          />
        </div>
      </form>
    </div>
  );
};

export default CreateEvent;

